export const appName = "Head Spa napohodu";
